import {
	SEARCH_HIGHLIGHT_FILTER,
	BUILD_HIGHLIGHT_FILTER,
	TIMELINE_HIGHLIGHT_FILTER,
	VIEWDOCUMENTS_HIGHLIGHT_FILTER,
	SEARCH_CURRENT_TAGS,
	BUILD_CURRENT_TAGS,
	TIMELINE_CURRENT_TAGS,
	VIEWDOCUMENTS_CURRENT_TAGS,
	SEARCH_CURRENT_TAGS_EXCLUDE,
	BUILD_CURRENT_TAGS_EXCLUDE,
	TIMELINE_CURRENT_TAGS_EXCLUDE,
	VIEWDOCUMENTS_CURRENT_TAGS_EXCLUDE,
	CONCEPT_BASED_ON_ID_SUCCESS,
	CONCEPT_BASED_ON_ID_FAILED,
	RESET_HIGHLIGHT_FILTER,
	SAVE_HIGHLIGHT_STATE,
	UPDATE_ANNOTATION,
} from "../types"

const initialState = {
	search: {
		dates: false,
		concepts: true,
		emails: false,
		specificWord: false,
		annotation: false,
		specificWordExclude: false,
		searchWord: [],
		fromDate: "",
		toDate: "",
		loadedConcept: [],
		saveHighlightState: {},
		nativeView: false,
		date: [],
		email: [],
	},
	build: {
		dates: false,
		concepts: true,
		emails: false,
		specificWord: false,
		annotation: false,
		specificWordExclude: false,
		searchWord: [],
		fromDate: "",
		toDate: "",
		saveHighlightState: {},
		nativeView: false,
		date: [],
		email: [],
	},
	timeline: {
		dates: false,
		concepts: true,
		emails: false,
		specificWord: false,
		annotation: false,
		specificWordExclude: false,
		searchWord: [],
		fromDate: "",
		toDate: "",
		saveHighlightState: {},
		nativeView: false,
		date: [],
		email: [],
	},
	viewDocuments: {
		dates: false,
		concepts: true,
		emails: false,
		specificWord: false,
		annotation: false,
		specificWordExclude: false,
		searchWord: [],
		fromDate: "",
		toDate: "",
		saveHighlightState: {},
		nativeView: false,
		date: [],
		email: [],
	},
	searchTags: [],
	buildTags: [],
	timelineTags: [],
	viewDocumentsTags: [],
	searchTagsExclude: [],
	buildTagsExclude: [],
	timelineTagsExclude: [],
	viewDocumentsTagsExclude: [],
	annotations: false,
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case SEARCH_HIGHLIGHT_FILTER:
			return { ...state, search: action.payload }
		case BUILD_HIGHLIGHT_FILTER:
			return { ...state, build: action.payload }
		case TIMELINE_HIGHLIGHT_FILTER:
			return { ...state, timeline: action.payload }
		case VIEWDOCUMENTS_HIGHLIGHT_FILTER:
			return { ...state, viewDocuments: action.payload }
		case SEARCH_CURRENT_TAGS:
			return { ...state, searchTags: action.payload }
		case BUILD_CURRENT_TAGS:
			return { ...state, buildTags: action.payload }
		case TIMELINE_CURRENT_TAGS:
			return { ...state, timelineTags: action.payload }
		case VIEWDOCUMENTS_CURRENT_TAGS:
			return { ...state, viewDocumentsTags: action.payload }
		case SEARCH_CURRENT_TAGS_EXCLUDE:
			return { ...state, searchTagsExclude: action.payload }
		case BUILD_CURRENT_TAGS_EXCLUDE:
			return { ...state, buildTagsExclude: action.payload }
		case TIMELINE_CURRENT_TAGS_EXCLUDE:
			return { ...state, timelineTagsExclude: action.payload }
		case VIEWDOCUMENTS_CURRENT_TAGS_EXCLUDE:
			return { ...state, viewDocumentsTagsExclude: action.payload }
		case CONCEPT_BASED_ON_ID_SUCCESS:
			const filterData = { ...state.search }
			filterData.loadedConcept = [...filterData?.loadedConcept, ...action.payload]
			return { ...state, search: filterData }
		case CONCEPT_BASED_ON_ID_FAILED:
			return { ...state }
		case RESET_HIGHLIGHT_FILTER:
			const data = { ...state.search }
			data.loadedConcept = []
			return { ...state, search: data }
		case SAVE_HIGHLIGHT_STATE:
			return { ...state, saveHighlightState: action.payload }
		case UPDATE_ANNOTATION:
			return { ...state, annotation: action.payload }
		default:
			return state
	}
}
